import React, { useState, useEffect } from 'react'
import { useSpring, animated, config } from 'react-spring'
import { keyframes } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import icon from '../img/icon.png';

const Loading = ({ props }) => {

    const fadeIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })

    return (
        <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
            <CircularProgress
                variant="determinate"
                sx={{
                    color: (theme) =>
                        theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                }}
                size={100}
                thickness={3}
                {...props}
                value={100}
            />
            <CircularProgress
                variant="indeterminate"
                disableShrink
                sx={{
                    color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
                    animationDuration: '1000ms',
                    position: 'absolute',
                    left: 0,
                    top: '-1px',
                    left: '-1px',
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: 'round',
                    },
                }}
                size={102}
                thickness={4}
                {...props}
            />
            <Typography align="center" variant="h5" sx={{ marginTop: '10px' }}>Loading...</Typography>
        </Box>

    )
}
export default Loading;